import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
  Spinner,
  Progress, // YENİ: Progress bileşenini import ediyoruz.
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Email, GSM,Date,Status } from "./contactlistCol";

import DateModal from "components/Common/DateModal";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import FilterModal from "components/Common/FilterModal";

import {
  getSubEducation as onGetSubEducation,
  addSubEducation as onAddSubEducation,
  updateSubEducation as onUpdateSubEducation,
  deleteSubEducation as onDeleteSubEducation,
  getProductSubSubCategory as onGetProductSubSubCategory,
  
  addProductSubSubCategory as onAddProductSubSubCategory,
  addReservation as onAddReservation,
  addUsersLessonsType as onAddUsersLessonsType,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { ExportToExcel2 } from "ExportToExcel2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const ContactsList = props => {
  const tableRef = useRef(null);

   const [lessonTypesMap, setLessonTypesMap] = useState(new Map());
  const [lessonsMap, setLessonsMap] = useState(new Map());
  
  // DEĞİŞTİ: Yükleme ve ilerleme state'leri
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // YENİ: Yükleme yüzdesini tutacak state

  //meta title
  document.title = "Alt Başlık | TriMentor ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getUser, setUser] = useState([]);
  const [getFilterCheckModal, setFilterCheckModal] = useState(false);
  const [getFilterModal, setFilterModal] = useState(false);
  const [getFilterData, setFilterData] = useState([]);
  const [getSelectDateFinish, setSelectDateFinish] = useState(null);
  const [getSelectDate, setSelectDate] = useState(null);
  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategory, setCategory] = useState([]);

  const [getType, setType] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Book_SubSubject_Title) || "",
      desc: (contactEdit && contactEdit.LessonSubSubject_Desc) || "",
      sort: (contactEdit && contactEdit.Sort) || "",

    },
    validationSchema: Yup.object({
    
    }),
    onSubmit:async (values) => {

      if (isEdit) {
        const updateUser = {
          ID: contactEdit.ID,
          Book_SubSubject_Title: values.title,
          Sort: values.sort,
          IsActive: getIsActive,
          Book_Subject_ID: getCategoryID,
        };
        dispatch(onUpdateSubEducation(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {


        const newUser = {
          Book_SubSubject_Title: values["title"],
          Sort: values["sort"],
          IsActive: getIsActive,
          Book_Subject_ID: getCategoryID,
        };
        // save new user

   
       dispatch(onAddSubEducation(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

    const { users2 } = useSelector(state => ({
    users2: state.contacts.productSubSubCategory,
  }));


  const { users } = useSelector(state => ({
    users: state.contacts.educationSubItem,
  }));
  const [modal, setModal] = useState(false);
    const [getExcelModal, setExcelModal] = useState(false)

  const [isEdit, setIsEdit] = useState(false);
  const [getIsActive, setIsActive] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
      {
        Header: "ID",
        accessor: "ID",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Başlık",
        accessor: "Book_SubSubject_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Konu",
        accessor: "Book_Subject.Book_Subject_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Sıralama",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Aktiflik Durumu",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },


    

     {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


<Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      } 
    ],
    []
  );


  const _getAuthData = async () => {

    await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getLessonSubjectEfso/select/`)
      .then((res) => {
        setCategory(res.data)
      })
  }

  useEffect(() => {
    _getAuthData()

  }, [getCategory]);


  useEffect(() => {
    if (users && !users.length) {

        dispatch(onGetSubEducation(null))
    
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
   // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };



  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setCategoryID(user.Book_Subject_ID)

    setIsActive(user.IsActive)
    setIsEdit(true);


    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSubEducation(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setIsEdit(false);
    toggle();
  };


  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }


  const _onFilterClick = (val,active) => {
  

    if(active == true){
      const dataFilter =  users.filter(x=> x.Users_ID == val)
      setFilterData(dataFilter)
      setFilterCheckModal(true)

      setFilterModal(false)
    }else{
      const dataFilter =  users.filter(x=> x.Users_ID == val)
      setFilterData(dataFilter)
      setFilterCheckModal(true)

      setFilterModal(false)

    }
 
  }

 const [mainSubjectsMap, setMainSubjectsMap] = useState(new Map());

useEffect(() => {
    const fetchMainSubjectsAndBuildMap = async () => {
      console.log("Ana konular veritabanından çekiliyor...");
      try {
        const response = await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getLessonSubjectEfso/select/`);
        
        const subjects = response.data;
        const newMap = new Map();

        for (const subject of subjects) {
          if (subject.Sort) {
            newMap.set(subject.Sort.toString(), subject.ID);
          }
        }

        setMainSubjectsMap(newMap);
        console.log("Ana konu haritası başarıyla oluşturuldu.", newMap);

      } catch (error) {
        console.error("Ana konular çekilirken hata oluştu:", error);
        alert("Ana konular veritabanından çekilemedi. Lütfen sayfayı yenileyin.");
      }
    };

    fetchMainSubjectsAndBuildMap();
  }, []);

// DEĞİŞTİ: Fonksiyon tamamen güncellendi.
const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (mainSubjectsMap.size === 0) {
        alert("Ana konu verileri henüz yüklenmedi veya bulunamadı. Lütfen bekleyin veya sayfayı yenileyin.");
        return;
    }

    setLoading(true);
    setUploadProgress(0); // YENİ: İlerlemeyi sıfırla

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet);

        const totalRows = data.length; // YENİ: Toplam satır sayısını al

        // DEĞİŞTİ: Döngü for...of'dan for'a çevrildi ve içerik try...catch ile sarmalandı
        for (let i = 0; i < totalRows; i++) {
          const row = data[i];
          try {
            const konuKodu = row["Konu kodu"]?.toString().trim();
            const konuAdı = row["Konu"]?.toString().trim();

            if (!konuKodu || !konuAdı) {
              console.warn(`Satır ${i + 2} atlanıyor: Eksik 'Konu Kodu' veya 'Konu' bilgisi.`, row);
              continue;
            }
            
            // Ana konu ID'sini haritadan bul
            const parentSubjectId = mainSubjectsMap.get(konuKodu);

            if (!parentSubjectId) {
              console.warn(`Satır ${i + 2} atlanıyor: '${konuAdı}' için ana konu (Kod: ${konuKodu}) veritabanında bulunamadı.`);
              continue;
            }

            const subSubjectPayload = {
              Book_SubSubject_Title: konuAdı,
              Book_Subject_ID: parentSubjectId,
              Sort: parseInt(konuKodu, 10) || 0,
              IsActive: true,
            };
            
            await dispatch(onAddSubEducation(subSubjectPayload));

          } catch (rowError) {
             console.error(`Excel'in ${i + 2}. satırı işlenirken hata oluştu ve atlandı. Hata:`, rowError, "İşlenen Veri:", row);
          } finally {
            // YENİ: Hata olsa da olmasa da ilerlemeyi güncelle
            const progress = ((i + 1) / totalRows) * 100;
            setUploadProgress(progress);
          }
        }
        
        alert("Excel içe aktarımı tamamlandı! Hatalar için geliştirici konsolunu kontrol edin.");

      } catch (err) {
        console.error("Excel dosyası işlenirken genel bir hata oluştu:", err);
        alert("Excel dosyası işlenirken bir hata oluştu. Lütfen konsolu kontrol edin.");
      } finally {
        setLoading(false);
        setUploadProgress(0); // YENİ: İşlem bitince ilerlemeyi sıfırla
        dispatch(onGetSubEducation(null));
      }
    };
    reader.readAsBinaryString(file);
    e.target.value = null;
  };

  const handleClick = () => {
    document.getElementById('subSubjectFileInput').click();
  };


  return (
    <React.Fragment>
      <FilterModal
        handleSelectChangeCompany= {_onFilterClick}
        show={getFilterModal}
        getCategoryCompany={getUser}
        onCloseClick={() => setFilterModal(false)}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Alt Başlık Gir" />

          {/* DEĞİŞTİ: Yükleme butonu ve input alanı aynı kaldı, ilerleme çubuğu eklendi */}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Button color="success" className="btn-rounded" onClick={handleClick} disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          <span className="ms-2">İşleniyor...</span>
                        </>
                      ) : (
                        "Alt Konu Excel'ini Yükle"
                      )}
                    </Button>
                    <input
                      id="subSubjectFileInput"
                      type="file"
                      accept=".xlsx, .xls"
                      style={{ display: 'none' }}
                      onChange={handleFileUpload}
                    />
                  </div>

                  {/* YENİ: Progress bar'ı buraya ekliyoruz */}
                  {loading && (
                    <div className="mt-4">
                      <div className="d-flex justify-content-between mb-1">
                        <span>Alt Konular İşleniyor...</span>
                        <span>{Math.round(uploadProgress)}%</span>
                      </div>
                      <Progress value={uploadProgress} color="success" striped animated />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={getFilterCheckModal == true ? getFilterData : users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddPayment={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "AltBaşlık Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                               {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Sıralama</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                placeholder="Sıralama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sort || ""}
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                               {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="d-flex">
                          <div className="square-switch">

                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
                         
                        </div>
                        <div className="mb-3">
                              <Label className="form-label">Kitap Başlığı Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                               <option value="">Lütfen Seçim Yapınız</option>
                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Book_Subject_Title}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);